const removeEvent = function ({ commit }) {
  commit("CLEAR_EVENT");
  return Promise.resolve(undefined);
};

export default removeEvent;
